import {SponsorNames} from './sponsorNames.js';
import {PhoneNumbers} from './phoneNumbers.js';

export var Inviter = function(inviterData) {
    var inviter = {};
    
    // Constructor
    if (inviterData) {
        inviter.id = inviterData.id;
        inviter.type = inviterData.type;
        inviter.country = inviterData.country;
        inviter.profilePictureUrl = inviterData.profilePictureUrl;
        inviter.profileThumbnailUrl = inviterData.profileThumbnailUrl;
        inviter.preferredName = inviterData.preferredName;

        inviter.names = SponsorNames(inviterData.names);
        inviter.phoneNumbers = PhoneNumbers(inviterData.phoneNumbers);
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------
    
    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------
    
    return inviter;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/inviter.js
// module id = 356
// module chunks = 0